import request from '../request'
export const getallcollect = () => request({ method: 'get', url: '/api/hotel/allcollect' })